import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=32e207ea&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=32e207ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e207ea",
  null
  
)

export default component.exports